import { states } from "@/common/data";

export const dummyAddressData = [
  {
    id: "1",
    building_number: "123",
    street: "Main Street",
    city: "Lagos",
    state: "Lagos",
    lga: "Ikeja",
    country: "Nigeria",
    landmark: "Near the big mall",
    isDefault: true,
  },
  {
    id: "2",
    building_number: "123",
    street: "Cottage Yard",
    city: "Lagos",
    state: "Lagos",
    lga: "Victoria Island",
    country: "Nigeria",
    landmark: "Near the big mall",
  },
  {
    id: "3",
    building_number: "190",
    street: "Adeniji Street",
    city: "Ota",
    state: "Ogun",
    lga: "Ota",
    country: "Nigeria",
    landmark: "Near Convenant University",
  },
];

export const newAddressForm = [
  {
    inputType: "selectParent",
    prompt: "State",
    name: "state",
    placeholder: "Select your state",
    fullWidth: false,
    options: states,
    rules: {
      minLength: {
        expectedValue: 1,
        errorMessage: "State must be selected",
      },
    },
  },
  {
    inputType: "selectChild",
    prompt: "Local Government Area",
    name: "lga",
    placeholder: "Select your LGA",
    fullWidth: false,
    options: states,
    parentName: "state",
    rules: {
      minLength: {
        expectedValue: 1,
        errorMessage: "Lga must be selected",
      },
    },
  },
  {
    inputType: "input",
    prompt: "City",
    name: "city",
    placeholder: "Enter your city",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 2,
        errorMessage: "City must be at least 2 characters long",
      },
    },
  },
  {
    inputType: "input",
    prompt: "Street",
    name: "street",
    placeholder: "Enter your street",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 2,
        errorMessage: "Street must be at least 2 characters long",
      },
    },
  },
  {
    inputType: "input",
    prompt: "Building number",
    name: "building_number",
    placeholder: "Enter your building number",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 2,
        errorMessage: "Building number must be at least 2 characters long",
      },
    },
  },
  {
    inputType: "input",
    prompt: "Postal code",
    name: "postal_code",
    placeholder: "Enter your postal code",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 2,
        errorMessage: "Postal code must be at least 2 characters long",
      },
    },
  },
  {
    inputType: "input",
    prompt: "Landmark",
    name: "landmark",
    placeholder: "Enter your landmark",
    fullWidth: false,
    rules: {
      minLength: {
        expectedValue: 2,
        errorMessage: "Landmark must be at least 2 characters long",
      },
    },
  },
];
